import { FC, useContext } from "react";
import { AppContext } from "../../context/index";
import { useMediaQuery } from "iuvity-ui-components/dist/hooks";

interface DescriptionProps {
    label: string;
}

export const DescriptionBox: FC<DescriptionProps> = ({
    label,
}) => {

    const isBigScreen = useMediaQuery('(min-width: 1920px)');
    const {
        t,
      } = useContext(AppContext);

    return (
        <div
            className="layout-pagedescription-box"
            style={{
                marginLeft: isBigScreen ? 'calc(128px + 352px)' : '128px',
                marginRight: '128px',
                marginTop: 'var(--padding-level-thirty-two)',
                marginBottom: '0px',
            }}
        >
            <div
                dangerouslySetInnerHTML={{ __html: t(label) }}
                style={{
                    padding: '0px var(--padding-level-twenty-four)',
                    lineHeight: '1.5',
                    fontFamily: 'var(--fontBarlowRegular)',
                    fontSize: 'var(--font-size-md)',
                }}
            />
        </div>
    )
};
